module.exports = __webpack_public_path__ + "img/card-basic.aca5f16a.png";